import React from 'react';
import { makeStyles } from '@mui/styles';
import { Button } from '@mui/material';

const useStyles = makeStyles({
    root: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
    },
    form: {
        display: 'flex',
        flexDirection: 'column',
        gap: '1rem',
    },
});

const Login = () => {
    const classes = useStyles();
    let AUTH_URL = '';

    let scriptLoadInitiated = false;
    React.useEffect(() => {
        const fetchData = async () => {
        if (scriptLoadInitiated) {
            return;
        } 
        scriptLoadInitiated = true;
        try {
            const response = await fetch('/api/auth-init');
            const data = await response.json();
            const { SignInURL } = data;
            AUTH_URL = SignInURL;
        } catch (error) {
            console.error('Error fetching data:', error);
        }
        };

        fetchData();
    }, []);

    const handleSubmit = (e) => {
        window.location.href = AUTH_URL;
        e.preventDefault();
        // Add your login logic here
    };

    return (
        <div className={classes.root}>
            <div>
                <h3>Welcome to the Login Page!</h3>
                <p>Please click the button below to login.</p>
                <form className={classes.form} onSubmit={handleSubmit}>
                    <Button variant="contained" color="primary" type="submit" name="loginButton">
                        Login
                    </Button>
                </form>
            </div>
        </div>
    );
};

export default Login;